var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:`shipping-list-item-status font-weight-bold rounded-lg ${_vm.statusColorVariant}`,attrs:{"title":_vm.statusStrings[_vm.shipping.status]}},[_vm._v("\n  "+_vm._s(_vm.shipping.status)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }